import { render } from "./UpdateDepositView.vue?vue&type=template&id=1955c171&scoped=true"
import script from "./UpdateDepositView.vue?vue&type=script&lang=js"
export * from "./UpdateDepositView.vue?vue&type=script&lang=js"

import "./UpdateDepositView.vue?vue&type=style&index=0&id=1955c171&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1955c171"]])

export default __exports__